import { FunctionComponent, useEffect, useRef } from 'react';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { themeState } from 'components/common/Managers/SettingsManager.state';
import * as K from 'common/constants';
import { GraphConfigType } from 'components/dashboards/types';
import { HoneyCombChartDataType } from 'common/types';
import { renderFn } from './util';

import './HoneyCombChart.scss';

// *
// * @prop chartData                  Data to be displayed using chart
// * @prop height                     height of parent div
// * @prop columns                    column values for the data
// * @config                          contains all the graph config options
// */
interface HoneyCombProps {
  chartData: HoneyCombChartDataType[][];
  height: number | null;
  config: GraphConfigType;
  columns: string[];
}

const HEADER_HEIGHT_PERCENTAGE = 10;

export const HoneyComb: FunctionComponent<HoneyCombProps> = (props) => {
  const {
    honeyCombColor = K.HONEYCOMB_COLOR_OPTIONS[0],
    honeyCombThresholds = [],
    honeyCombLinkTo = '',
  } = props.config;
  const groupEl = useRef(null);
  const svgEl = useRef(null);
  const zoomEl = useRef(null);
  const [width, setWidth] = useState(0);
  const theme = useRecoilValue(themeState);
  // To calculate height of the honeycomb chart remove header height percentage from total block height
  const height = props.height ? props.height - (HEADER_HEIGHT_PERCENTAGE / 100) * props.height : 0;
  useEffect(() => {
    const { width, height } = (svgEl.current as any).getBoundingClientRect();
    setWidth(width);
    const renderProps = {
      width,
      height,
      parentGroupEl: groupEl.current,
    };
    renderFn(
      props.chartData,
      renderProps,
      groupEl,
      props.columns,
      honeyCombThresholds,
      honeyCombColor,
      theme,
      honeyCombLinkTo,
    );
  });
  return (
    <svg ref={svgEl} viewBox={`0 0 ${width} ${height}`}>
      <rect ref={zoomEl} />
      <g ref={groupEl} className="g" />
    </svg>
  );
};
